import { Button, Typography } from "@mui/material";
import React from "react";
import { useNavigate} from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { SITE_CONFIG } from "../config";

export default function Logo({textOnly = true}) {
const navigate = useNavigate();
const theme = useTheme();
const isXs = useMediaQuery(theme.breakpoints.down('md')); 

const handleLogoClick = (e) => {
    e.preventDefault();
    navigate("/", { replace: true })
}
    return (
        <Button onClick={(e) => handleLogoClick(e)} color="inherit" underline="none">
            <Typography sx={{m:2}} variant={isXs? "h6" : "h4"}>{SITE_CONFIG.NAME}</Typography>
        </Button>
    );
}